module.exports = __webpack_public_path__ + "static/media/SE_Child_Ordkjede.17f9ca83.mp4";